import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDWizardModalWrapper } from 'Views/Page/Content/Modal/Layouts/FDWizardModalWrapper';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';

export const SelectAssetLiabilityTypeTemplate = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDWizardModalWrapper resource={resource}>
      <MetaLayoutRemainingFields />
    </FDWizardModalWrapper>
  );
};
